import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=5b3f7514&scoped=true"
import script from "./mapping.vue?vue&type=script&lang=js"
export * from "./mapping.vue?vue&type=script&lang=js"
import style0 from "./mapping.vue?vue&type=style&index=0&id=5b3f7514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f7514",
  null
  
)

export default component.exports